import React from 'react'
import Typography from '@mui/material/Typography';
import { Box, Grid2 as Grid, Tooltip } from '@mui/material';
import { globalstyles as styles } from '../lib/definitions';


export const common_data_entry = [
    { id: 'name', label: 'Nome', import_id: 'azienda' },
    { id: 'cdaua', label: 'Codice AUA azienda', import_id: 'cdaua' },
    { id: 'regione', label: 'Regione', import_id: 'regione' },
    { id: 'provincia', label: 'Provincia', import_id: 'provincia' },
    { id: 'comune', label: 'Comune', import_id: 'comune' },
]



export const PropertyLabel = (props) => {
    const element = props.element
    return (
        <>
        <Tooltip title={
                element?.cdaua
        }>
            <Box
                sx={{
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: '12px'
                }}>
                {element?.name}
            </Box>

        </Tooltip>
        </>
    )

}


export const PropertyButton = (props) => {
    const element = props.element
    return (
        <>
            <Typography
                component="div"
                variant="subtitle1"
                color="inherit"
                sx={{
                    color: 'black',
                    fontWeight: 'bold',
                    position: 'relative',
                    fontSize: '12px'
                }}>
                {element.name}
            </Typography>
            <Typography
                component="span"
                variant="subtitle1"
                color="inherit"
                sx={{
                    position: 'relative',
                    fontSize: '11px',
                    textTransform: 'none'
                }}>
                {element.cdaua}
            </Typography>
        </>
    )

}



export const PropertyRow = (props) => {

    const element = props.element
    const fontSize = props.fontSize || '10px'
    return (
        <Grid container >
            <Grid size={3} sx={{ fontSize: fontSize, color: 'blue' }}>
                {element.cdaua}
            </Grid>
            <Grid size="grow" sx={{ fontSize: fontSize, fontWeight: 'bold' }}>
                {element.name}
            </Grid>
            <Grid size="auto" sx={{ fontSize: fontSize }}>
            </Grid>

        </Grid>
    )

}
export const PropertyHeader = () => (
    <Grid container >
        <Grid item size={3} sx={styles.listHeader}>
            aua 
            
        </Grid>
        <Grid item size="grow" sx={styles.listHeader}>
            Nome
        </Grid>
        <Grid size="grow" sx={styles.listHeader}>
        </Grid>
    </Grid>

)
